export default "__VITE_ASSET__8a268974__"